export const en_common = {
  // ... (All previous keys from Header to Footer remain the same)
  home: 'Home',
  about: 'About Us',
  contact: 'Contact',
  bookNow: 'Book Now',
  myAccount: 'My Account',
  heroTitle: 'Discover the Beauty of the Sea with Our Exceptional Boat Trips',
  heroSubtitle: 'Embark on an unforgettable adventure across crystal-clear blue waters',
  exploreTrips: 'Explore Trips',
  happyCustomers: 'Happy Customers',
  tripsCompleted: 'Trips Completed',
  yearsExperience: 'Years Experience',
  ourTrips: 'Our Trips',
  dayTrip: 'Day Trip',
  eveningTrip: 'Evening Trip',
  dayTripDesc: 'Enjoy a full day of swimming, snorkeling, and island exploration',
  eveningTripDesc: 'Experience magical sunsets with music and refreshments',
  duration: 'Duration',
  price: 'Price',
  bookTrip: 'Book Trip',
  aboutUs: 'About Us',
  aboutTitle: 'Why Choose FireBoat?',
  aboutDesc: 'We are a leading company in organizing boat trips, providing exceptional and safe experiences in the most beautiful marine locations.',
  professionalCrew: 'Professional Crew',
  professionalCrewDesc: 'Highly experienced team trained to the highest standards',
  modernBoats: 'Modern Boats',
  modernBoatsDesc: 'Fleet of boats equipped with the latest technology',
  safetyFirst: 'Safety First',
  safetyFirstDesc: 'Advanced safety equipment and strict safety procedures',
  fullService: 'Full Service',
  fullServiceDesc: 'Everything you need for a perfect trip in one place',
  contactTitle: 'Contact Us',
  contactDesc: 'We are here to answer all your questions and help you plan your perfect trip',
  getInTouch: 'Get in touch',
  address: 'Address',
  workingHours: 'Working Hours',
  fullName: 'Full Name',
  email: 'Email',
  message: 'Message',
  sendMessage: 'Send Message',
  messageSent: 'Your message has been sent successfully',
  messageError: 'Could not send your message. Please try again.',
  quickLinks: 'Quick Links',
  privacyPolicy: 'Privacy Policy',
  refundExchangePolicy: 'Refund & Exchange Policy',
  followUs: 'Follow Us',
  myBookings: 'My Bookings',
  settings: 'Settings',
  loggedInAs: 'Logged in as',
  chooseTravelDate: 'Choose trip date',
  

  // --- NEW & UPDATED KEYS START HERE ---
  
  // Trip Types Section
  selectYourAdventure: 'Select Your Adventure',
  seatsAvailable: 'Seats Available',
  seats: 'Seats',
  capacity: 'Capacity',
  ofTotal: 'of',
  categoriesFound: 'Categories found',
  fullyBooked: 'Fully Booked',
  
  // Sub-trip Names
  individualAdventure: 'Individual Adventures',
  privateAdventure: 'Private Adventures',
  sunsetCruise: 'Sunset Cruise',
  privateKayak: 'Private Cayo ',
  eveningKayak: 'Evening Cayo ',

  // Booking Modal
  bookingFor: 'Booking for',
  selectDateTime: 'Select Date & Time',
  holdTimer: 'Your spot is held for',
  seatsReserved: 'Seats Reserved',
  holdId: 'Hold ID',
  timerExpired: 'Reservation Expired',
  timerExpiredMessage: 'Unfortunately, your 15-minute hold has expired. Please start over.',
  step: 'Step',
  of: 'of',
  selectTrip: 'Select Trip',
  passengerDetails: 'Passenger Details',
  addOns: 'Add-Ons',
  phoneVerification: 'Phone Verification',
  payment: 'Payment',
  confirmation: 'Confirmation',
  previous: 'Previous',
  back: 'Back',
  next: 'Next',
  confirmBooking: 'Book Now',
  selectTripType: 'Select Trip Type',
  sar: 'SAR',
  selectDate: 'Select Date',
  selectTime: 'Select Time',
  numberOfPassengers: 'Number of Passengers',
  adults: 'Adults',
  children: 'Children',
  infants: 'Infants',
  years: 'years',
  passengerInformation: 'Passenger Information',
  passengerName: 'Passenger Name',
  yearOfBirth: 'Year of Birth',
  idType: 'ID Type',
  nationalId: 'National ID / Iqama',
  passport: 'Passport',
  borderNumber: 'Border Number',
  idNumber: 'ID Number',
  enterBorderNumber: 'Enter border number',
  phoneCase: 'Waterproof Phone Case',
  each: 'each',
  meal: 'Onboard Meal',
  total: 'Total',
  processing: 'Processing...',
  payNow: 'Pay Now',
  paymentRetryFailed: 'Payment retry failed. Please try again.',
  paymentNotCompleted: 'Payment Not Completed',
  paymentNotCompletedDesc: 'Payment process was not completed. You can retry now to complete your booking.',
  paymentFailed: 'Payment Failed',
  bookingConfirmed: 'Booking Confirmed!',
  bookingConfirmationMessage: 'Thank you! Your trip has been successfully booked. A confirmation has been sent to your phone.',
  bookingReference: 'Booking Reference',
  done: 'Done',
  date: 'Date',
  time: 'Time',
  passengers: 'Passengers',
  phone: 'Phone',
  invalidVerificationCode: 'Invalid verification code. Please try again.',
  sending: 'Sending...',
  sendVerificationCode: 'Send Verification Code',
  verifyPhoneNumber: 'Verify Phone Number',
  changePhoneNumber: 'Change Phone Number',
  enterVerificationCode: 'Enter verification code (6 digits)',
  forTestingUseCode: 'For testing, use code: 123456',
  verificationCodeSentTo: 'Verification code sent to',
  pleaseEnterMobile: 'Please enter your mobile number to verify your booking. We will send you a 6-digit verification code.',
  pricing: 'Pricing',
  adultPrice: 'Adult Price',
  childPrice: 'Child Price',
  infantPrice: 'Infant Price',
  free: 'Free',
  included: 'Included',
  fullBoatBooking: 'Full boat booking',
  summary: 'Summary',
  subtotal: 'Subtotal',
  groupDiscount: 'Group Discount',
  groupDiscountHint: 'Book with a group and get special discounts!',
  addOnsTotal: 'Add-ons Total',
  paymentMethod: 'Payment Method',
  payWithApplePay: 'Pay with Apple Pay',
  payWithTabby: 'Proceed with Tabby',
  cardNumber: 'Card Number',
  cardExpiry: 'MM/YY',
  cardCVC: 'CVC',
  cardMada: 'Card / Mada',
  visa: 'Visa',
  mada: 'Mada',
  tabby: 'Tabby',
  applePay: 'Apple Pay',

  // Bank Transfer
  bankTransferInstructions: 'Transfer Instructions',
  bankAccountDetails: 'Bank Account Details',
  accountName: 'Account Name',
  bankName: 'Bank Name',
  accountNumber: 'Account Number',
  iban: 'IBAN',
  
    // Common
  loading: 'Loading...',
  success: 'Success',
  error: 'Error occurred',
  tryAgain: 'Try Again',
  close: 'Close',
  available: 'Available',
  noTripsAvailable: 'No trips available at the moment',
  noSlotsAvailable: 'No available times for this date',
  pleaseSelectAnotherDate: 'Please select another date',
  
  // Cancel Page Helpers
  howCanWeHelp: 'How can we help?',
  checkCardBalance: 'Make sure your card has sufficient balance',
  verifyCardDetails: 'Verify your card details are correct',
  enableOnlinePayment: 'Make sure online payment is enabled on your card',
  tryAnotherPaymentMethod: 'Try another payment method',
  havingPaymentDifficulty: 'Having difficulty completing payment?',
  
  // Extras Step - new keys
  additionalServices: 'Additional Services',
  selectOptionalExtras: 'Select optional extras to enhance your experience',
  selectedExtras: 'Selected Extras',
  extrasTotal: 'Extras Total',
  noExtrasAvailable: 'No extras available at the moment',
  enterPassengerDetails: 'Enter passenger details and contact information',
  contactName: 'Contact Name',
  enterContactName: 'Enter contact name',
  contactEmail: 'Contact Email',
  enterContactEmail: 'Enter contact email',
  tripSummary: 'Trip Summary',
  trip: 'Trip',
  currency: 'SAR',

  // Passenger Count Step - new keys only
  passengerCount: 'Passenger Count',
  selectPassengerCount: 'Select passenger count and view price summary',
  priceSummary: 'Price Summary',
  minimumPassengersNotice: 'You must book at least {{min}} passengers for this trip.',

  // Passenger Details Step - new keys only
  contactInformation: 'Contact Information',
  adult: 'Adult',
  child: 'Child',
  infant: 'Infant',
  enterPassengerName: 'Enter passenger name',
  birthYear: 'Birth Year',
  selectBirthYear: 'Select birth year',
  enterIdNumber: 'Enter ID number',
  birthDate: 'Date of Birth',
  selectBirthDate: 'Select date of birth',
  day: 'Day',
  month: 'Month',
  year: 'Year',
  hijriCalendarToggle: 'Hijri calendar',
  hijri: 'Hijri',
  gregorian: 'Gregorian',
  hijriCalendar: 'Calendar: Hijri',
  gregorianCalendar: 'Calendar: Gregorian',
  borderGuardNoticeTitle: 'Note:',
  borderGuardNotice: 'Per Border Guard regulations, please enter accurate passenger details to issue the sailing permit.',

  // Payment Step
  selectPaymentMethod: 'Select Payment Method',
  choosePreferredPayment: 'Choose your preferred payment method to complete your booking',
  bookingSummary: 'Booking Summary',
  tripType: 'Trip Type',
  passengersCount: 'Passengers',
  persons: 'persons',
  timeSlot: 'Time',
  addonsTotal: 'Addons',
  sarCurrency: 'SAR',
  grandTotal: 'Total',
  tax: 'Tax',
  totalExcludingTax: 'Total (excl. tax)',
  includingTax: 'incl. tax',
  excludingTax: 'excl. tax',
  paymentMethodLabel: 'Payment Method',
  loadingPaymentMethods: 'Loading payment methods...',
  // Discounts UI
  availableDiscounts: 'Available Discounts',
  childDiscount: 'Child discount',
  infantPriceLabel: 'Infant price',
  
  // Order Creation
  pleaseFillAllFields: 'Please fill all required fields',
  creatingOrder: 'Creating order',
  proceedToPayment: 'Proceed to Payment',
  orderCreationFailed: 'Failed to create order',
  
  // Authentication 
  login: 'Login',
  logout: 'Logout',
  welcome: 'Welcome',
  optional: 'Optional',
  required: 'Required',
  phoneNumber: 'Phone Number',
  enterPhoneNumber: 'Enter your phone number to send verification code',
  verificationCode: 'Verification Code',
  enterFullName: 'Enter Full Name',
  enterEmail: 'Enter Email',
  createAccount: 'Create Account',
  resendCode: 'Resend Code',
  accountCreated: 'Account created successfully',
  codeResent: 'Code resent successfully',
  invalidPhoneNumber: 'Invalid phone number',

  // Authentication - New
  loginWithPhone: 'Login with Phone',
  loginWithEmail: 'Login with Email',
  saudiPhoneOnly: 'Saudi numbers only (Example: 05XXXXXXXX)',
  enterEmailPassword: 'Enter email and password',
  enterPassword: 'Enter Password',
  confirmPassword: 'Confirm Password',
  createNewAccount: 'Create New Account',
  fillDetailsBelow: 'Fill in the details below',
  alreadyHaveAccount: 'Already have an account? Sign in',
  
  // Validation messages - New
  passwordRequired: 'Password is required',
  passwordMinLength: 'Password must be at least 6 characters',
  passwordMismatch: 'Passwords do not match',
  invalidEmail: 'Invalid email address',
  verified: 'Verified',
  
  // Error messages - Enhanced
  phoneAlreadyExists: 'Phone number already registered. Please login instead of registering.',
  emailAlreadyExists: 'Email address already registered. Please use a different email.',
  emailNotFound: 'Email address not registered. Please check the email or create a new account.',
  incorrectPassword: 'Incorrect password. Please try again.',
  invalidCredentials: 'Invalid login credentials. Please check your email and password.',
  invalidData: 'Invalid data entered. Please try again.',
  
  // Messages - New
  loginSuccess: 'Login successful',
  registrationFailed: 'Registration failed',
  emailRequired: 'Email is required',
  pleaseEnterRealEmail: 'Please enter a real email address',
  authenticationRequired: 'Authentication required',
  pleaseLoginToContinue: 'Please login to continue',
  
  // Toast messages - New
  otpSendFailed: 'Failed to send code',
  accountCreatedSuccessfully: 'Account created successfully',
  registrationCompleteMessage: 'Please enter your name to complete registration',
  testingCode: 'For testing',
  
  // Placeholders and labels - New
  phoneNumberLabel: 'Phone Number',
  phoneNumberPlaceholder: 'Phone Number (05XXXXXXXX)',
  otpPlaceholder: '000000',
  passwordPlaceholder: 'Enter Password',
  confirmPasswordPlaceholder: 'Confirm Password',
  accountCreationNote: 'If you don\'t have an account, a new account will be created automatically',
  fillDataBelow: 'Fill in the details below',
  createNewAccountWithPhone: 'To create a new account, use phone number login',
  verifiedLabel: 'Verified',
  or: 'or',
  
  // Additional Auth Keys
  loginOrRegister: 'Login or Register',
  phoneRequired: 'Phone number is required',
  verificationCodeRequired: 'Verification code is required',
  verifying: 'Verifying...',
  completing: 'Creating account...',
  loggingIn: 'Logging in...',
  emailUpdatedSuccessfully: 'Email updated successfully',
  emailConflictInfo: 'Email belongs to another account. Logged in without changing it.'
  ,
  // Forgot password
  forgotPassword: 'Forgot password?',
  enterYourEmail: 'Enter your email to receive a reset code',
  enterYourEmailToReceiveCode: 'Enter your email to receive a verification code',
  enterYourEmailToResetPassword: 'Enter your email to receive a reset code',
  sendResetLink: 'Send reset code',
  resetEmailSent: 'We\'ve sent a password reset code to your email',
  backToLogin: 'Back to login'
  ,
  // Password reset via code
  resetCodeTitle: 'Enter reset code',
  resetCodeSubtitle: 'We sent a 6-digit code to your email',
  resetCodePlaceholder: '000000',
  verifyCode: 'Verify code',
  createNewPassword: 'Create new password',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  passwordUpdated: 'Password updated successfully',
  codeInvalidOrExpired: 'Code invalid or expired',
  
  // Success Page translations
  successTitle: 'Thank you! Your booking is confirmed',
  orderDetails: 'Order Details',
  orderNumber: 'Order Number',
  orderCreatedDate: 'Order Created Date',
  // tripName, tripDate, tripTime already exist above
  creditCardTap: 'Credit Card (Tap)',
  cashOnDelivery: 'Cash on Delivery',
  status: 'Status',
  orderProcessing: 'Processing',
  nextSteps: 'Next Steps',
  emailConfirmationStep: 'A confirmation will be sent via SMS/Email',
  accountViewStep: 'You can view your ticket in My Bookings',
  arriveEarlyStep: 'Please arrive 30 minutes before departure',
  downloadTicket: 'Download Ticket (PDF)',
  ticketNotReadyYet: 'Ticket is not ready yet. Please check again shortly.',
  ticketWillAppearWhenReady: 'Ticket will appear when ready',
  backToHome: 'Back to Home',
  needHelp: 'Need help?',
  contactSupport: 'Contact Support',
  showFullServerResponse: 'Show full server response',
  responseAlsoPrintedInConsole: 'This response is also printed in the browser console',
  verifyingPaymentInProgress: 'Verifying your payment, please wait...',
  orderCreatedSuccess: 'Your order has been created successfully',
  orderCreatedCod: 'Your order has been created. You will pay on boarding.',
  orderCreatedTamara: 'Payment completed successfully via Tamara! You will receive a confirmation message shortly.',
  paymentMethodTamara: 'Tamara - Buy Now Pay Later',
  paymentTapSuccess: 'Payment successful. Your booking is confirmed.',
  paymentTapPending: 'Payment is pending. We will notify you once it is confirmed.',
  paymentTapIssue: 'We could not verify the payment. If the amount was deducted, please contact support.',
  paymentCancelledUser: 'Payment Cancelled',
  paymentCancelledUserDesc: 'You cancelled the payment process. No amount has been charged.',
  paymentCancelledUserDescTamara: 'You cancelled the payment on Tamara page. No amount has been charged.',
  paymentFailedGateway: 'Payment Failed',
  paymentFailedGatewayDesc: 'An error occurred while processing your payment. Please try again or use another payment method.',
  paymentFailedTamara: 'Payment Failed via Tamara',
  paymentFailedTamaraDesc: 'An error occurred while processing payment via Tamara. Please try again or use another payment method.',
  couldNotVerifyOrder: "We couldn't verify your order. Please contact us.",
  orderRemovedAfterFailure: 'This order was removed after a failed payment. Please create a new booking to continue.',
  orderDetailsUnavailable: 'Order details are no longer available for this booking.',
  retryNotAvailable: 'Retry payment is not available for this order.',
  
  // Tickets Page (new)
  myTickets: 'My Tickets',
  viewPrintTickets: 'View and print your tickets',
  backToBookings: 'Back to Bookings',
  backToTickets: 'Back to Tickets',
  allTickets: 'All Tickets',
  noTicketsFound: 'No Tickets Found',
  noTicketsDescription: 'You don\'t have any tickets yet',
  showingTickets: 'Showing {{count}} of {{total}} tickets',
  errorLoadingTickets: 'Error loading tickets',
  ticketNotFound: 'Ticket not found',
  viewTicket: 'View Ticket',
  viewDetails: 'View Details',
  downloadPDF: 'Download PDF',
  
  // Security messages
  mustLoginToViewTicket: 'You must be logged in to view the ticket',
  ticketNotYours: 'This ticket does not belong to you',
  invalidOrUsedLink: 'Invalid or already used link',
  failedToVerifyLink: 'Failed to verify link',
  invalidLinkNoToken: 'Invalid link - verification token required',
  
  // Ticket Card (only new keys)
  boatTripTicket: 'Boat Trip Ticket',
  ticketNotAvailable: 'Ticket not available',
  tripDetails: 'Trip Details',
  tripName: 'Trip Name',
  pricingSummary: 'Pricing Summary',
  customerInformation: 'Customer Information',
  customerName: 'Customer Name',
  orderStatus: 'Order Status',
  created: 'Created',
  paid: 'Paid',
  pricingDetails: 'Pricing Details',
  basePrice: 'Base Price',
  discount: 'Discount',
  addons: 'Add-ons',
  
  // Passenger Types
  passengerType_adult: 'Adult',
  passengerType_child: 'Child',
  passengerType_infant: 'Infant',
  
  // ID Types
  idType_national_id: 'National ID',
  idType_passport: 'Passport',
  idType_border_number: 'Border Number',
  idType_other: 'Other',
  
  // Order Status
  status_processing: 'Processing',
  status_completed: 'Completed',
  status_pending: 'Pending',
  status_cancelled: 'Cancelled',
  
  // Trip Details Modal (only new keys)
  departureTime: 'Departure Time',
  totalPassengers: 'Total Passengers',
  people: 'people',
  hoursRange_day: '6-8 Hours',
  hoursRange_evening: '3-4 Hours',
  userId: 'User ID',
  locationMap: 'Location map',
  characters: 'characters',
  contactInfo: 'Contact Info',
  today: 'Today',
  for: 'for',
  to: 'to',
  andAbove: 'and above',
  ofAdultPrice: 'of adult price',
  reload: 'Reload',
  
  // Additional UI Keys
  completed: 'Completed',
  pending: 'Pending',
  support: 'Support',
  managePreferences: 'Manage Preferences',
  change: 'Change',
  changePassword: 'Change Password',
  notifications: 'Notifications',
  emailNotifications: 'Email Notifications',
  emailNotificationsDesc: 'Receive booking notifications via email',
  smsNotifications: 'SMS Notifications',
  smsNotificationsDesc: 'Receive text messages about your bookings',
  marketingEmails: 'Marketing Emails',
  marketingEmailsDesc: 'Receive offers and updates',
  savePreferences: 'Save Preferences',
  notificationsUpdated: 'Notifications updated',
  errorUpdatingNotifications: 'Error updating notifications',
  
  // My Bookings Page
  viewManageBookings: 'View and manage your bookings',
  allBookings: 'All Bookings',
  noBookingsFound: 'No Bookings Found',
  noBookingsDescription: 'You don\'t have any bookings yet. Start by booking your first trip!',
  tripDate: 'Trip Date',
  tripTime: 'Trip Time',
  loadMore: 'Load More',
  loadMoreNotImplementedYet: 'Coming soon: Load more',
  errorDownloadingTicket: 'Error downloading ticket',
  failedToLoadBookings: 'Failed to load bookings',
  retry: 'Retry',
  
  // Booking Status
  statusCompleted: 'Completed',
  statusProcessing: 'Processing',
  statusPending: 'Pending',
  statusOnHold: 'On Hold',
  statusCancelled: 'Cancelled',
  statusFailed: 'Failed',
  statusRefunded: 'Refunded',
  
  // My Account Page
  manageProfileBookings: 'Manage profile and bookings',
  member: 'Member',
  memberSince: 'Member since',
  bookingStatistics: 'Booking Statistics',
  totalBookings: 'Total Bookings',
  totalSpent: 'Total Spent',
  quickActions: 'Quick Actions',
  viewAllBookings: 'View all bookings',
  bookNewTrip: 'Book a new trip',
  supportComingSoon: 'Coming soon: Support center',
  confirmLogout: 'Are you sure you want to logout?',
  logoutSuccess: 'Logged out successfully',
  
  // Settings Page
  profileInformation: 'Profile Information',
  profileUpdated: 'Profile updated',
  errorUpdatingProfile: 'Error updating profile',
  currentPassword: 'Current Password',
  passwordsMismatch: 'Passwords do not match',
  passwordTooShort: 'Password is too short',
  passwordChanged: 'Password changed successfully',
  errorChangingPassword: 'Error changing password',
  dangerZone: 'Danger Zone',
  dangerZoneDesc: 'Account deletion is permanent and cannot be undone',
  deleteAccount: 'Delete Account',
  confirmDeleteAccount: 'Are you sure you want to permanently delete your account?',
  accountDeletionNotImplemented: 'Coming soon: Account deletion',
  edit: 'Edit',
  
  // Coupon Keys
  haveCoupon: 'Have a coupon code?',
  appliedCoupon: 'Applied Coupon',
  enterCouponCode: 'Enter coupon code',
  apply: 'Apply',
  removeCoupon: 'Remove Coupon',
  couponDiscount: 'Coupon Discount',
  couponHint: 'Coupon will be validated and applied to selected products',
  pleaseEnterCouponCode: 'Please enter coupon code',
  invalidCoupon: 'Invalid or expired coupon',
  couponApplied: 'Coupon applied successfully',
  couponRemoved: 'Coupon removed',
  bookingDataRestored: 'Previous booking data restored',
  
  // Pricing Details (Unified)
  subtotalExTax: 'Trip Value (ex tax)',
  totalExTax: 'Total (ex tax)',
  totalInclTax: 'Total (incl tax)',
  shipping: 'Shipping',
  
  // Validation Messages
  fieldRequired: 'This field is required',
  nameTooShort: 'Name is too short (minimum 3 characters)',
  mustBeAdult: 'Must be an adult (12+ years)',
  mustBeChild: 'Must be a child (2-11 years)',
  mustBeInfant: 'Must be an infant (under 2 years)',
  nationalIdMustBe10Digits: 'National ID must be 10 digits',
  borderNumberMustBe10Digits: 'Border number must be 10 digits',
  
};

export default en_common;
